export const Mode = {
    Hover: 'hover',
    ClickToClose: 'click-to-close',
};
//# sourceMappingURL=constants.js.map